import React from 'react';
import { useWatch } from 'react-hook-form';
import { TotalEntries } from '@atlas-frontend/sdk';

export const ClassifierFormTotalEntries = () => {
  const [categoriesCount, categoryGroupsCount, combinedGroupsCount] = useWatch({
    name: [
      'categories.length',
      'categoryGroups.length',
      'combinedGroups.length',
    ],
  });
  return (
    <TotalEntries
      count={categoriesCount + categoryGroupsCount + combinedGroupsCount}
    />
  );
};
